const user = {
  state: {
    info: JSON.parse(localStorage.getItem('YUNY_INFO')) || {}
  },

  mutations: {
    SET_INFO(state, user) {
      localStorage.setItem('YUNY_INFO', user)
      state.info = user
    }
  },

  actions: {
    // 登出
    Logout ({ commit }) {
      return new Promise((resolve,reject) => {
        // logout().then((res) => {
        //
        //   router.go(0)
        // }).catch((err) => {
        //   reject(err)
        // })
      })
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/account.js